<div class="flex-row" [formGroup]="form">
  <button (click)="onRemove()" bw-icon-button-legacy><bw-icon-legacy iconName="minus" size="32"></bw-icon-legacy></button
  ><input
    type="text"
    class="currency-input"
    [value]="quantity"
    [formControlName]="fcName"
    currencyMask
    [options]="currencyMaskOptions"
  /><button (click)="onAdd()" bw-icon-button-legacy><bw-icon-legacy iconName="add" size="32"></bw-icon-legacy></button>
</div>
